'use client'
import { tagada, alegreyaSans } from "@/app/global-fonts";
import dynamic from "next/dynamic";
const PDFViewer = dynamic(() => import('../../_components/PDFViewer'), { ssr: false });

const thesisURL = `https://rg-website-content.sfo2.digitaloceanspaces.com/RG_Ethnography.pdf`;

export default function ReimagineAncientGrainTrend() {
  return (
    <main
      className={`${tagada.className}
      bg-clay
      pt-16
      flex
      flex-col
      items-center
      `}
    >
      <h1
        className={`text-sand
        text-fluid-md
        text-center
        mb-8
        `}
      >
        REIMAGINING THE ANCIENT GRAIN TREND: ETHNOGRAPHY
      </h1>
      <p
        className={`text-fluid-md
                md:text-fluid-base
                text-earth
                p-8
                ml-8
                mr-8
                mb-8
                ${alegreyaSans.className}
                bg-sand
                rounded-[2rem]`}
      >
        Through recipe, story, and market analysis, we engage our audience to
        re-imagine the healing that is possible if we step outside the bounds of
        corporate visions for the ancient grain trend. This ethnography is a
        good place to start if you want to learn why the current food system is
        a threat to environmental and social justice, and how centering cultural
        contexts of ancient grains can lead us towards a more just consumption
        of our world&apos;s diverse grains.
      </p>      
      <PDFViewer url={thesisURL} expectedTotalPages={68} backgroundColor="#f8f2eaff"/>
    </main>
  );
}
